import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import EscudoNacional from "@/components/EscudoNacional";

export default function Footer() {
  const { lang, t } = useI18n();
  const base = `/${lang}`;

  return (
    <footer className="kv-footer" data-testid="site-footer" id="contact">
      <div className="kv-flag-strip" aria-hidden="true" style={{ marginBottom: "3rem" }} />
      <div className="kv-container">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "2.5rem",
          }}
          className="footer-grid"
        >
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "1rem" }}>
              <EscudoNacional size={44} title={t("footer.escudoLabel")} />
              <span className="font-display" style={{ color: "#fff", fontSize: "1.4rem", fontWeight: 700 }}>
                {t("brand.name")}
              </span>
            </div>
            <p style={{ maxWidth: 380, lineHeight: 1.55 }}>{t("footer.about")}</p>
            <div style={{ marginTop: "1rem", fontSize: "0.8rem", color: "#94a3b8", letterSpacing: "0.06em", textTransform: "uppercase" }}>
              {t("footer.flagLabel")}
            </div>
          </div>
          <div>
            <h4>{t("footer.navTitle")}</h4>
            <Link to={base} data-testid="footer-home">{t("nav.home")}</Link>
            <a href={`${base}#programs`} data-testid="footer-programs">{t("nav.programs")}</a>
            <a href={`${base}#resources`} data-testid="footer-resources">{t("nav.resources")}</a>
            <a href={`${base}#contact`} data-testid="footer-contact">{t("nav.contact")}</a>
          </div>
          <div>
            <h4>{t("footer.legalTitle")}</h4>
            <Link to={`${base}/privacy`} data-testid="footer-privacy">{t("nav.privacy")}</Link>
            <Link to={`${base}/cookies`} data-testid="footer-cookies">{t("nav.cookies")}</Link>
            <Link to={`${base}/terms`} data-testid="footer-terms">{t("nav.terms")}</Link>
          </div>
          <div>
            <h4>{t("footer.contactTitle")}</h4>
            <div style={{ fontSize: "0.92rem", lineHeight: 1.65 }}>
              <div>{t("footer.address")}</div>
              <div style={{ marginTop: "0.5rem" }}>
                <a href="tel:+5117304820">{t("footer.phone")}</a>
              </div>
              <div>
                <a href="mailto:contacto@killavox.com">{t("footer.email")}</a>
              </div>
              <div style={{ marginTop: "0.5rem", color: "#94a3b8" }}>{t("footer.hours")}</div>
            </div>
          </div>
        </div>

        <div style={{ height: 1, background: "rgba(255,255,255,0.08)", margin: "2.5rem 0 1.5rem" }} />

        <div className="kv-legal-block" style={{ maxWidth: 980 }}>
          {t("footer.legalDetails")}
        </div>
        <div className="kv-legal-block" style={{ marginTop: "0.75rem", maxWidth: 980 }}>
          {t("footer.compliance")}
        </div>

        <div style={{ marginTop: "2rem", display: "flex", flexWrap: "wrap", gap: "1rem", justifyContent: "space-between", alignItems: "center", color: "#94a3b8", fontSize: "0.82rem" }}>
          <div>{t("footer.rights")}</div>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem" }}>
            <span
              aria-hidden="true"
              style={{
                display: "inline-block",
                width: 30,
                height: 20,
                background:
                  "linear-gradient(to right, #d0111b 0 33.33%, #ffffff 33.33% 66.66%, #d0111b 66.66% 100%)",
                borderRadius: 3,
              }}
            />
            <span>Perú · Lima</span>
          </div>
        </div>
      </div>
      <style>{`
        @media (min-width: 768px) {
          .footer-grid { grid-template-columns: 1.4fr 1fr 1fr 1.2fr !important; }
        }
      `}</style>
    </footer>
  );
}
